/* eslint-disable react-hooks/exhaustive-deps */
import { Dropdown, Menu, Button } from "antd"
import React, { useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { DownOutlined } from '@ant-design/icons'

interface ShelterMenuProps {
  shelterUuid: string
  onLoad?: () => void
}

interface SheltersParams {
  shelterUuid: string
  activeTab: string
}

export const ShelterMenuList = [
  {
    key: "general",
    label: "General",
  },
  // {
  //   key: "limit-control",
  //   label: "Limit Control",
  // },
  {
    key: "pet-profile",
    label: "Pet Profile",
  },
  {
    key: "discount-reason",
    label: "Discount Reason",
  },
  {
    key: "payment",
    label: "Payment",
  },
  {
    key: "question",
    label: "Questions",
  },
  {
    key: "pet-restore",
    label: "Restore deleted pets",
  },
  {
    key: "product",
    label: "Products",
  },
  {
    key: "tax",
    label: "Taxes",
  },
  {
    key: "iframe",
    label: "Iframe",
  },
  {
    key: "kennel-card",
    label: "Kennel Card",
  },
  {
    key: "in-person",
    label: "In Person",
  },
  {
    key: "kiosk",
    label: "Kiosk",
  },
  {
    key: "process-tag",
    label: "Process Tag",
  },
  {
    key: "pet-characteristics",
    label: "Pet Characteristics",
  },
]

export const ShelterMenu = ({ shelterUuid, onLoad }: ShelterMenuProps) => {
  const baseUrl = `/organization/shelter/${shelterUuid}`
  const params = useParams<SheltersParams>()
  const activeTab = ShelterMenuList.find((menu) => params.activeTab === menu.key)?.label

  useEffect(() => {
    onLoad && onLoad()
  }, [])

  return (
    <Dropdown
      trigger={["click"]}
      overlay={<Menu>
        {ShelterMenuList.map(menu => {
          return (
            <Menu.Item
              key={menu.key}
              style={{
                background: params.activeTab === menu.key ? '#fff0f2' : "",
                color: params.activeTab === menu.key ? '#e52e6b' : ""
              }}>
              <Link to={`${baseUrl}/${menu.key}`}>{menu.label}</Link>
            </Menu.Item>
          )
        })}
      </Menu>}>
      <Button >{activeTab} <DownOutlined style={{ color: '#e52e6b' }} />  </Button>
    </Dropdown>
  )
}